import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Message } from 'semantic-ui-react'

class Dismissible extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      visible: true
    }

    // Bind events
    this.onDismiss = this.onDismiss.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Call onDismiss if any
    if (
      prevState.visible
      &&
      !this.state.visible
      &&
      _.isFunction(this.props.onDismiss)
    ) {
      this.props.onDismiss()
    }
  }

  onDismiss() {
    this.setState({
      visible: false
    })
  }

  render() {
    const { onDismiss, ...props } = this.props
    return (
      this.state.visible
        ? <Message
            onDismiss={this.onDismiss}
            {...props}
          />
        : null
    )
  }
}

Dismissible.propTypes = {
  icon: PropTypes.string,
  header: PropTypes.string,
  content: PropTypes.string.isRequired,
  color: PropTypes.string,
  onDismiss: PropTypes.func
}

export default Dismissible



// WEBPACK FOOTER //
// ./src/components/elements/Dismissible.js